module.exports = __webpack_public_path__ + "media/stylesheets/images/marker-icon-2x-4c2b05dbc31774c11394e6c0aa88cdec.png";